import protoRoot from "../proto-root";

const name = "changeMonitoringModeRPCRequest";

function create(monitoringModeType) {
  const MonitoringModeType = protoRoot.lookupEnum("comm.MonitoringModeType");
  const ChangeMonitoringModeRPCRequest = protoRoot.lookupType(
    "comm.ChangeMonitoringModeRPCRequest"
  );

  const request = ChangeMonitoringModeRPCRequest.create({
    monitoringModeType: MonitoringModeType.values[monitoringModeType]
  });

  return { payload: request, name };
}

export default {
  create,
  name
};
